<template>
  <!-- 功能体验 -->
  <div class="experience">
    <lists :el-tabs__header ="id"></lists>
  </div>
</template>

<script>
import lists from "../components/Lists";
export default {
  name: "experience",
  components: { lists },
  data() {
    return {
      id: this.$map.expcategoryId,
    };
  },
};
</script>

<style scoped lang="less">
// .experience {
// }
</style>
